import { render, staticRenderFns } from "./HrHero.vue?vue&type=template&id=24187835"
import script from "./HrHero.vue?vue&type=script&lang=js"
export * from "./HrHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports